import { mapEnumToOptions } from '@abp/ng.core';

export enum ProfileChangeType {
  None = 'None',
  EmailChangeRequest = 'EmailChangeRequest',
  EmailChangeConfirm = 'EmailChangeConfirm',
  AddressChange = 'AddressChange',
  Other = 'Other',
}

export const profileChangeTypeOptions = mapEnumToOptions(ProfileChangeType);
